export const LEVERAGE_OPTIONS = [
  { value: '1', label: '1:1' },
  { value: '10', label: '1:10' },
  { value: '20', label: '1:20' },
  { value: '25', label: '1:25' },
  { value: '30', label: '1:30' },
  { value: '50', label: '1:50' },
  { value: '100', label: '1:100' },
  { value: '200', label: '1:200' },
  { value: '300', label: '1:300' },
  { value: '400', label: '1:400' },
  { value: '500', label: '1:500' },
  { value: '1000', label: '1:1000' },
] as const;

export const transferAccounts = [
  { value: 'wallet', label: 'Wallet (main balance)' },
  { value: 'mt5-001234', label: 'MT5 - 001234 (USD)' },
  { value: 'mt5-001235', label: 'MT5 - 001235 (EUR)' },
];

export const tradingAccounts = [
  { value: 'mt5-001234', label: 'MT5 - 001234 (USD) - Balance $5,230.00' },
  { value: 'mt5-001235', label: 'MT5 - 001235 (EUR) - Balance EUR 2,100.00' },
];
export const payoutMethods = [
  { value: 'bank', label: 'Bank transfer' },
  { value: 'wallet', label: 'E-Wallet (Skrill / Neteller)' },
  { value: 'card', label: 'Card (where available)' },
  { value: 'crypto', label: 'Crypto (USDT, BTC, ETH)' },
];

export interface AccountOption {
  value: string;
  label: string;
}

export type AccountType = AccountOption;
export type Currency = AccountOption;
export type LeverageOption = AccountOption;
export type Country = AccountOption;
